// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import mammoth from "mammoth";
import ElementUI from "element-ui";
import "@/utils/drag.js";
import "@/utils/css/animate.min.css";
import "@/utils/css/global.css";
import "@/utils/css/index.css";
import "element-ui/lib/theme-chalk/index.css";
// import Vue from 'vue'
import { RegionSelects } from "v-region";
Vue.component("v-region-selects", RegionSelects);
import createPersistedState from "vuex-persistedstate";
Vue.prototype.$baseUrl = "https://api.hnzyxsbh.com/";
Vue.filter("dateFormat", function(value) {
  let date = new Date(value * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let m = date.getMinutes();
  m = m < 10 ? "0" + m : m;
  let s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; //多种时间格式的拼接
});
Vue.filter("dateFormats", function(value) {
  let date = new Date(value * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let m = date.getMinutes();
  m = m < 10 ? "0" + m : m;
  let s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  return y + "-" + MM + "-" + d + " "; //多种时间格式的拼接
});

import confirmMy from "./components/tan.js";
Vue.prototype.$confirmMy = confirmMy;

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(mammoth);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js